import type {createDataApi} from '../api/dataApi';
import type {DetailPaginationItem} from '../types/DetailPaginationItem';
import type {RowControlFetchStrategy} from '../types/RowControlFetchStrategy';

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export async function loadDetailPaginationItems(
  http: Pick<ReturnType<typeof createDataApi>, 'getDataByQuery' | 'getDataIdsByQuery'>,
  queryId: string,
  offset: number,
  limit: number,
  strategy: RowControlFetchStrategy
): Promise<DetailPaginationItem[] | undefined> {
  if (strategy.type === 'id') {
    return (await http.getDataIdsByQuery(queryId, offset, limit, false)) ?? undefined;
  }

  const rows = await http.getDataByQuery(
    queryId,
    offset,
    limit,
    false,
    Object.values(strategy.additionalRouteParams).map((source) => source.columnKey)
  );

  return rows?.map((row) => {
    const additionalRouteParams: Record<string, string> = {};
    for (const [param, source] of Object.entries(strategy.additionalRouteParams)) {
      const cell = row.cells[source.columnKey];
      const value = cell?.value;
      const resolved = source.valueKey && isRecord(value) ? value[source.valueKey] : value;

      if (typeof resolved !== 'string' || resolved.length === 0) {
        return {id: row.id, rowNumber: row.rowNumber};
      }
      additionalRouteParams[param] = resolved;
    }

    return {id: row.id, rowNumber: row.rowNumber, additionalRouteParams};
  });
}
